import { TripProviderTypes } from '../../lib/types/models/trip-provider/trip-provider'

export const mapTripProviderToInput = (
  tripProvider: TripProviderTypes.Full
): TripProviderTypes.Input => {
  return {
    companyName: tripProvider.companyName,
    comments: tripProvider.comments
  }
}
